import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitogujratcab() {



const cardData = {
  keyword: " Mumbai to Gujarat Cab",

headingDescription:
  "Omshree Cab offers reliable and comfortable Mumbai to Gujarat cab services for travelers planning a long-distance journey across Maharashtra into the culturally rich state of Gujarat. Whether you are traveling for business, leisure, pilgrimage, or family trips, our cab service ensures a safe, convenient, and enjoyable journey with experienced drivers and well-maintained vehicles. Gujarat is known for its vibrant cities, historical landmarks, temples, wildlife sanctuaries, and coastal attractions. We provide flexible booking options including one-way rides, round-trip packages, and multi-day travel plans with transparent per-kilometer pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With punctual pickups from anywhere in Mumbai, professional chauffeurs skilled in long-distance highway travel, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Gujarat cab booking.",

topPlaces: [
  {
    title: "Gir National Park",
    description:
      "Gir National Park is a famous wildlife sanctuary in Gujarat, renowned for being the only natural habitat of the Asiatic lion. Visitors can enjoy safari tours, wildlife photography, and observe diverse flora and fauna. Traveling by cab from Mumbai allows travelers to explore this unique ecological destination comfortably, with flexibility for early morning and late evening wildlife excursions."
  },
  {
    title: "Somnath Temple",
    description:
      "Somnath Temple is one of the twelve Jyotirlingas of Lord Shiva and a major pilgrimage destination in Gujarat. The temple features stunning architecture with intricate carvings and a serene seaside location. Pilgrims and tourists visit to offer prayers, participate in rituals, and witness the evening aarti on the Arabian Sea. A cab journey from Mumbai ensures a hassle-free and comfortable trip to this spiritual landmark."
  },
  {
    title: "Dwarkadhish Temple",
    description:
      "Dwarkadhish Temple, located in Dwarka, is dedicated to Lord Krishna and is one of the Char Dham pilgrimage sites. The temple attracts thousands of devotees and tourists every year. Its grand architecture, colorful interiors, and religious ceremonies make it a must-visit for spiritual travelers. A cab ride from Mumbai provides safe, convenient access to this revered temple."
  },
  {
    title: "Rann of Kutch",
    description:
      "The Rann of Kutch is a vast salt desert in Gujarat famous for its white salt marshes and the annual Rann Utsav festival. Visitors can enjoy cultural performances, handicrafts, local cuisine, and scenic desert views. A cab journey from Mumbai allows travelers to comfortably experience this unique geographical and cultural destination while exploring nearby towns and villages."
  },
  {
    title: "Saputara Hill Station",
    description:
      "Saputara is the only hill station in Gujarat, known for its lush greenery, pleasant climate, and scenic viewpoints. Tourists can enjoy boating at Saputara Lake, trekking, nature walks, and panoramic views from Sunset Point and Artist Village. Traveling by cab from Mumbai allows travelers to reach this serene destination conveniently and plan their sightseeing efficiently."
  },
  {
    title: "Laxmi Vilas Palace",
    description:
      "Laxmi Vilas Palace in Vadodara is an architectural marvel and residence of the royal family. Visitors can explore the palace grounds, museum exhibits, and grand halls showcasing Indo-Saracenic design. A cab ride from Mumbai provides convenient access to this historic site and the surrounding cultural attractions of Vadodara."
  },
  {
    title: "Champaner-Pavagadh Archaeological Park",
    description:
      "This UNESCO World Heritage Site near Vadodara includes ancient forts, temples, mosques, and stepwells, reflecting Gujarat’s medieval architectural heritage. Visitors can explore the historic ruins and enjoy panoramic hilltop views. A cab journey from Mumbai allows travelers to comfortably visit and explore this historically rich park."
  },
  {
    title: "Modhera Sun Temple",
    description:
      "Modhera Sun Temple, dedicated to the Sun God, is an architectural masterpiece known for its intricate carvings and stepwell design. Tourists can admire the detailed sculptures, take photographs, and learn about its historical significance. A cab ride from Mumbai ensures hassle-free travel to this iconic temple."
  },
  {
    title: "Vadodara Museum & Picture Gallery",
    description:
      "The Vadodara Museum & Picture Gallery showcases artifacts, sculptures, paintings, and historical exhibits related to Gujarat’s culture and history. Visitors can spend time exploring its diverse collections and learning about regional heritage. Traveling by cab allows tourists to conveniently include this museum in their Gujarat itinerary."
  },
  {
    title: "Saputara Tribal Museum",
    description:
      "Saputara Tribal Museum provides insights into the indigenous tribes of Gujarat, their lifestyle, culture, and traditions. Visitors can explore displays of traditional artifacts, costumes, and handicrafts. A cab journey from Mumbai makes it easy to reach this museum and combine it with other Saputara sightseeing attractions."
  }
],



services: [
{
name: "Mumbai to Gujarat Cab",
description: "Mumbai to Gujarat cab service offers comfortable interstate transportation from Mumbai to major cities across Gujarat including Ahmedabad, Surat, Vadodara, and Rajkot. This route is popular for business travel, tourism visits, and family trips. Our vehicles are well maintained and suitable for long-distance highway journeys with spacious seating and luggage capacity. Professional drivers ensure safe driving and punctual pickup services from homes, offices, hotels, railway stations, and Mumbai airport terminals. Air-conditioned vehicles ensure relaxed travel throughout the journey. Ideal for corporate travel, family vacations, and tourism trips across Gujarat. Flexible booking options allow passengers to plan convenient travel schedules."
},
{
name: "Mumbai to Surat Cab",
description: "Mumbai to Surat cab service provides comfortable transportation between Mumbai and Surat, one of Gujarat’s major commercial cities. This route is widely used for business travel, diamond industry visits, and family trips. Vehicles provide smooth highway performance and comfortable seating suitable for intercity travel. Professional drivers ensure punctual pickup and safe highway driving across the Mumbai–Surat route. Pickup services are available from homes, offices, hotels, railway stations, and Mumbai airport terminals. Ideal for business visits, tourism travel, and family journeys."
},
{
name: "Mumbai to Ahmedabad Cab",
description: "Mumbai to Ahmedabad cab service offers reliable long-distance travel between Mumbai and the largest city in Gujarat. Ahmedabad is famous for its business hubs, heritage sites, and cultural attractions. Vehicles provide comfortable seating and smooth highway performance suitable for interstate travel. Professional drivers ensure punctual pickup services across Mumbai and safe driving throughout the journey. Pickup is available from homes, offices, hotels, railway stations, and airport terminals."
},
{
name: "Mumbai to Vadodara Cab",
description: "Mumbai to Vadodara cab service provides dependable road transportation for travelers visiting the cultural city of Vadodara. Vehicles provide comfortable seating and reliable highway performance suitable for interstate journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals."
},
{
name: "Mumbai to Rajkot Cab",
description: "Mumbai to Rajkot cab service offers convenient interstate transportation for travelers visiting Rajkot in Gujarat. Vehicles provide smooth highway performance and comfortable seating suitable for long-distance travel. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals."
},
{
name: "Mumbai to Gujarat Taxi",
description: "Mumbai to Gujarat taxi service provides reliable transportation for travelers visiting different cities across Gujarat. Vehicles provide comfortable seating and smooth ride quality suitable for interstate highway journeys. Professional drivers ensure safe driving and punctual pickup services across Mumbai. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals."
},
{
name: "Mumbai to Gujarat Cab Service",
description: "Mumbai to Gujarat cab service offers dependable road travel for passengers visiting Gujarat for tourism, business travel, and family trips. Vehicles provide comfortable seating and reliable highway performance suitable for interstate travel. Professional drivers ensure punctual pickup services and safe driving throughout the journey."
},
{
name: "Cab from Mumbai to Gujarat",
description: "Cab from Mumbai to Gujarat provides convenient long-distance transportation for travelers visiting different cities across the state. Vehicles provide comfortable seating and smooth ride quality suitable for highway journeys. Professional drivers ensure punctual pickup and safe driving services across Mumbai."
},
{
name: "Taxi from Mumbai to Gujarat",
description: "Taxi from Mumbai to Gujarat offers dependable interstate travel options for passengers traveling to Gujarat for business, tourism, or family visits. Vehicles provide comfortable seating and reliable highway performance suitable for long-distance journeys."
},
{
name: "Mumbai to Gujarat Cab Booking",
description: "Mumbai to Gujarat cab booking allows travelers to easily reserve vehicles for interstate travel across Gujarat. Online and phone booking options provide instant confirmation and flexible ride scheduling. Vehicles provide comfortable seating and smooth highway performance suitable for long journeys."
},
{
name: "Mumbai to Gujarat Taxi Booking Online",
description: "Mumbai to Gujarat taxi booking online provides quick and convenient reservations for travelers planning interstate journeys. Passengers can schedule pickups and receive instant booking confirmation for their trips."
},
{
name: "Mumbai to Gujarat Cab Price",
description: "Mumbai to Gujarat cab price options provide transparent fare estimates based on vehicle category, distance, and travel duration. Travelers can choose sedans, SUVs, or MPV vehicles depending on comfort needs and group size."
},
{
name: "Mumbai to Gujarat Taxi Fare",
description: "Mumbai to Gujarat taxi fare services offer flexible pricing depending on vehicle type and travel duration. Passengers can choose economical sedans or spacious SUVs depending on their travel preferences."
},
{
name: "Mumbai to Gujarat One Way Cab",
description: "Mumbai to Gujarat one way cab service provides economical interstate transportation without return charges. Vehicles provide comfortable seating and smooth highway performance suitable for long-distance travel."
},
{
name: "Mumbai to Gujarat Round Trip Taxi",
description: "Mumbai to Gujarat round trip taxi service offers convenient transportation for passengers planning return journeys after visiting cities across Gujarat. Vehicles provide reliable travel for both directions."
}
],

tableData: [
["Mumbai to Gujarat Cab","Mumbai to Surat Cab"],
["Mumbai to Ahmedabad Cab","Mumbai to Vadodara Cab"],
["Mumbai to Rajkot Cab","Mumbai to Gujarat Taxi"],
["Mumbai to Gujarat Cab Service","Cab from Mumbai to Gujarat"],
["Taxi from Mumbai to Gujarat","Mumbai to Gujarat Cab Booking"],
["Mumbai to Gujarat Taxi Booking Online","Mumbai to Gujarat Cab Price"],
["Mumbai to Gujarat Taxi Fare","Mumbai to Gujarat One Way Cab"],
["Mumbai to Gujarat Round Trip Taxi","Gujarat Taxi from Mumbai"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Interstate Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in interstate travel from Mumbai to various cities across Gujarat such as Surat, Vadodara, Ahmedabad, Vapi, and Rajkot. They are familiar with major highways and border routes ensuring a safe and comfortable journey."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Omshree Cabs offers transparent pricing for Mumbai to Gujarat cab bookings. Customers receive clear details about per-kilometer charges, toll fees, and driver allowance before confirming the booking."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Service",
    WhyChoosedescription: "Our Mumbai to Gujarat cab service operates 24 hours a day. Whether you want to travel early morning, late night, or plan an urgent trip, we provide reliable cab booking anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in our fleet are well maintained, regularly cleaned, and fully air-conditioned to ensure passengers enjoy a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One-Way & Round Trip Options",
    WhyChoosedescription: "We offer flexible travel options including one-way cab bookings, round trips, and multi-day travel packages from Mumbai to Gujarat."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, luxury vehicles like Innova Crysta, and Tempo Travellers suitable for families and group travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, railway stations, and airports anywhere in Mumbai so your Gujarat journey begins smoothly."
  },
  {
    WhyChooseheading: "Trusted Interstate Cab Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for Mumbai to Gujarat trips. Our punctual drivers, comfortable vehicles, and professional service ensure a safe and hassle-free journey."
  }
]
};

const faqData = [
  { question: "Do you provide cab service from Mumbai to Gujarat?", answer: "Yes, Omshree Cabs provides reliable cab services from Mumbai to major cities in Gujarat including Surat, Vadodara, Ahmedabad, Vapi, and Rajkot." },
  { question: "Can I book a one-way cab from Mumbai to Gujarat?", answer: "Yes, we offer both one-way and round-trip cab services between Mumbai and various cities in Gujarat." },
  { question: "Which vehicles are available for Mumbai to Gujarat travel?", answer: "We provide sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers depending on group size." },
  { question: "Is the cab service available 24 hours?", answer: "Yes, our Mumbai to Gujarat cab service operates 24/7 for passenger convenience." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can we stop during the journey?", answer: "Yes, passengers can request stops during the journey for meals, rest, or refreshments." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially for interstate travel and weekend trips." },
  { question: "Do you provide pickup from Mumbai Airport?", answer: "Yes, we provide pickup from Mumbai Airport for travelers heading to Gujarat." },
  { question: "Do you provide cab services for business travel to Gujarat?", answer: "Yes, many business travelers book our cabs for travel between Mumbai and Gujarat for meetings and corporate visits." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ketan Patel",
    feedback:
      "We booked Omshree Cabs for our Mumbai to Surat trip. The driver was professional and the journey was very comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Nisha Shah",
    feedback:
      "Excellent interstate cab service. Clean vehicle and punctual driver made our Mumbai to Vadodara travel smooth.",
    rating: 5
  }
];









































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Gujarat Cab",
  "description": "Omshree Cab offers reliable cab services from Mumbai to Gujarat, including Surat, Ahmedabad, Vadodara, and Rajkot. Enjoy safe, comfortable, and flexible one-way or round-trip journeys with our well-maintained fleet of Innova, Ertiga, and Sedan cabs.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "940"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Mumbai to Gujarat Cab | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai to Gujarat cab with Omshree Cab for one-way or round-trip travel. Cover cities like Surat, Ahmedabad, Vadodara, and Rajkot. Safe and reliable cab service with Innova, Ertiga, and Sedan options." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/75.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitogujratcab;